module.exports = __webpack_public_path__ + "static/media/ic_carDisabledCircled.bb247533.svg";